package com.iptvplayer.web.ui

import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.width

/**
 * Color palette (plain CSS strings, applied via StyleScope.property for
 * safety). Mirrors the mobile/TV design system: deep space-blue surfaces,
 * violet→orchid accent gradient, gold for ratings.
 */
object Theme {
    const val bg = "#0a0d16"
    const val surface = "#121724"
    const val surfaceAlt = "#1d2436"
    const val card = "#151b2b"
    const val primary = "#7c6cff"
    const val primaryDim = "#5a4ae8"
    const val accentPink = "#b44cff"
    const val gold = "#ffc53d"
    const val text = "#f3f5fb"
    const val textDim = "#98a2b8"
    const val danger = "#ff5c7a"
    const val liveRed = "#ff3b5c"
    const val border = "#242c42"

    /** Signature accent sweep for buttons / active states. */
    const val accentGradient = "linear-gradient(135deg, #7c6cff 0%, #b44cff 100%)"

    /** Bottom scrim over poster imagery so overlaid titles stay readable. */
    const val posterScrim = "linear-gradient(180deg, rgba(10,13,22,0) 55%, rgba(10,13,22,0.92) 100%)"
}

fun StyleScope.fieldStyle() {
    width(100.percent)
    property("background", Theme.bg)
    property("border", "1px solid ${Theme.border}")
    property("border-radius", "10px")
    property("padding", "11px 13px")
    property("color", Theme.text)
    property("font-size", "15px")
    property("outline", "none")
    property("transition", "border-color .15s ease")
}

fun StyleScope.cardStyle() {
    property("background", Theme.card)
    property("border", "1px solid ${Theme.border}")
    property("border-radius", "14px")
}

/** Filled call-to-action with the signature gradient. */
fun StyleScope.accentButtonStyle() {
    property("background", Theme.accentGradient)
    property("border", "none")
    property("border-radius", "12px")
    property("color", "#ffffff")
    property("font-weight", "700")
    property("cursor", "pointer")
    property("box-shadow", "0 6px 18px rgba(124,108,255,0.35)")
}
